//Utilities
export { default as DuAuthenticationUtilities } from './src/Utilities/DuAuthenticationUtilities';
export { default as DuCache } from './src/Utilities/DuCache';
export { default as DuCommonTranslations } from './src/Utilities/DuCommonTranslations';
export { default as DuDateUtilities } from './src/Utilities/DuDateUtilities';
export { default as DuExcelUtilities } from './src/Utilities/DuExcelUtilities';
export { default as DuGlossaryUtilities } from './src/Utilities/DuGlossaryUtilities';
export { default as DuIcons } from './src/Utilities/DuIcons';
export { default as DuIconSrc } from './src/Utilities/DuIconSrc';
export { default as DuLogger } from './src/Utilities/DuLogger';
export { default as DuPersonalizationUtilities } from './src/Utilities/DuPersonalizationUtilities';
export { default as DuThemeUtilities } from './src/Utilities/DuThemeUtilities';
export { default as DuUploadUtilities } from './src/Utilities/DuUploadUtilities';
export { default as DuValidationUtilities } from './src/Utilities/DuValidationUtilities';
//External Libraries
if (window) {
    window.Driscolls_React_Utilities_Version = '3.18.0';
    window.Versions = window.Versions || [];
    if (
        window.Versions.findIndex((v) => {
            return v.package === 'driscolls-react-utilities';
        }) < 0
    ) {
        window.Versions.push({
            package: 'driscolls-react-utilities',
            name: "Driscoll's React Utilities",
            description: "Driscoll's React Utilities",
            version: window.Driscolls_React_Utilities_Version
        });
    }
}
